exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar {\r\n    border-bottom: 1px solid #ddd;\r\n    font-size: x-large;\r\n}\r\n\r\n.navbar-brand{\r\n    font-size: x-large;\r\n}\r\n\r\n.plus-icon{\r\n    color:Tomato;\r\n}\r\n\r\n.navbar-text{\r\n    -ms-touch-action: manipulation;\r\n        touch-action: manipulation;\r\n    text-decoration: none;\r\n}\r\n\r\n@media screen and (max-width: 320px) {\r\n    .navbar-brand{\r\n        font-size: 6vw;\r\n    }\r\n    .navbar {\r\n        font-size: 6vw;\r\n    }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/homePC/angular-comp/The-Top/src/app/core/header/header.component.css
// module id = ../../../../../src/app/core/header/header.component.css
// module chunks = main